import styled from "styled-components"

export const StyledTextFieldFormItem = styled.div`
  --label-width: 70px;

  display: flex;
  position: relative;
  width: 100%;
`
export const StyledLabel = styled.label`
  position: absolute;
  text-align: left;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 16px;
  line-height: 160%;
`

export const StyledTextarea = styled.textarea<{ $isError: boolean }>`
  resize: none;
  padding: 18.5px 16px;
  padding-left: var(--label-width);
  line-height: 120%;
  font-weight: 500;
  border-radius: 8px;
  outline: ${(props) =>
    props.$isError
      ? "1px solid var(--Schemes-Error, #B3261E) !important"
      : "0.5px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32))"};

  @supports (-webkit-touch-callout: none) {
    outline: ${(props) =>
      props.$isError
        ? "1px solid var(--Schemes-Error, #B3261E) !important"
        : "0.8px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32))"};
  }

  background: var(#fff);
  color: ${(props) =>
    props.$isError
      ? "var(--Schemes-Error, #B3261E)"
      : "var(--Schemes-Primary, #0DA3BA)"};

  text-align: right;
  width: 100%;
  height: 100%;
  font-size: 16px;

  &,
  &:focus,
  &:active,
  &:focus-visible {
    border: none;
  }

  &:focus,
  &:active,
  &:focus-visible {
    outline: 1px solid var(--Schemes-Primary, #0da3ba);
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--Schemes-Outline, rgba(0, 38, 58, 1));
    font-size: 16px;
    font-weight: 400;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--Schemes-Outline, rgba(0, 38, 58, 1));
    font-size: 16px;
    font-weight: 400;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`

export const DetailsTrailing = styled.div<{ $isUnit?: boolean }>`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--color-navy);
  pointer-events: none;
  ${(props) =>
    props.$isUnit &&
    `
    color: var(--Schemes-Primary, #0DA3BA);
    font-weight: 500;
    `}
`
